/* export const nonUSStates = [
    { id: 51, name: 'District of Columbia' },
    { id: 53, name: 'Guam' },
    { id: 54, name: 'Marshall Islands' },
    { id: 55, name: 'Northern Mariana Islands' },
    { id: 57, name: 'Puerto Rico' },
    { id: 58, name: 'Virgin Islands' },
  ] */

export const nonUSStates = [51, 53, 54, 55, 57, 58]

export const StatusOptions: { label: string; value: number }[] = [
  {
    label: 'Yes',
    value: 1,
  },
  {
    label: 'No',
    value: 0,
  },
]
